<ng-container *transloco="let t">
  @if ({ searchResult: searchResult$ | async }; as data) {
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="heading-size-4" id="modalTitle">
            {{ t('worksite_search_organisation') }}
          </h2>
          <p>{{ t('worksite_search_information_text') }}</p>
          <lib-search-bar
            [form]="form"
            [countries]="countries"
            (doSearch)="onSearch()"
          >
          </lib-search-bar>
          @if (data.searchResult && data.searchResult.bisnodeNotResponding) {
            <div class="alert alert-danger" role="alert">
              <p class="m-0">
                {{ t('worksite_search_error') }}
              </p>
            </div>
          }
          @if (data.searchResult && (searchIsPressed || backToSearch)) {
            <lib-search-result
              [countries]="countries"
              [result]="data.searchResult.result"
              [totalHits]="data.searchResult.totalAmount"
              [searchParams]="searchParams"
              [alreadySelectedWorksites]="alreadySelectedWorksites"
              [alreadySelectedFinanciers]="alreadySelectedFinanciers"
              [isFinancierSearch]="isFinancierSearch"
              (createWorksite)="onCreateWorksite($event)"
              (selectWorksite)="onSelectWorksite($event)"
              (createCompanyAndWorksite)="onCreateCompanyAndWorksite($event)"
            >
            </lib-search-result>
          }
        </div>
      </div>
    </div>
  }
</ng-container>
